import type { Dispatch, SetStateAction } from "react";

import styled from "styled-components";

import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

import { COMP_INTEL_ADS_FEATURE_COUNT, COMP_INTEL_FEATURE_COUNT, COMP_INTEL_SEO_FEATURE_COUNT } from "./constants";
import { Card, Container, Feature, FeatureList } from "./PackageItem/styledComponent";
import { CloseButton, Wrapper } from "./StyledComponents";

const CARD_FEATURE_COUNTS = [COMP_INTEL_FEATURE_COUNT, COMP_INTEL_SEO_FEATURE_COUNT, COMP_INTEL_ADS_FEATURE_COUNT];

const LoaderFeatureList = styled(FeatureList)`
    margin-top: 24px;
`;

interface IStepPackagesCIAndSEOAndAdsDesktopLoaderProps {
    setIsOpen?: Dispatch<SetStateAction<boolean>>;
}

export const StepPackagesCIAndSEOAndAdsDesktopLoader = ({
    setIsOpen,
}: IStepPackagesCIAndSEOAndAdsDesktopLoaderProps) => {
    return (
        <Wrapper data-automation="reactivation-packages-v2-loader">
            <CloseButton
                iconName="clear"
                iconSize="sm"
                type="flat"
                onClick={() => setIsOpen?.(false)}
                data-automation="reactivation-packages-v2-close"
            />
            <Container>
                {CARD_FEATURE_COUNTS.map((featureCount, index) => (
                    <Card
                        key={index}
                        isRecommended={false}
                    >
                        <Stack gap="16px">
                            <PixelPlaceholderLoader
                                width={100}
                                height={20}
                                borderRadius={4}
                            />

                            <Stack gap="8px">
                                <PixelPlaceholderLoader
                                    width={140}
                                    height={22}
                                    borderRadius={4}
                                />
                                <PixelPlaceholderLoader
                                    width={160}
                                    height={14}
                                    borderRadius={4}
                                />
                            </Stack>

                            <PixelPlaceholderLoader
                                width="100%"
                                height={40}
                                borderRadius={20}
                            />
                        </Stack>

                        <LoaderFeatureList>
                            {[...Array(featureCount).keys()].map((item) => (
                                <Feature key={item}>
                                    <PixelPlaceholderLoader
                                        width={20}
                                        height={20}
                                        borderRadius={4}
                                    />
                                    <PixelPlaceholderLoader
                                        width={150}
                                        height={12}
                                        borderRadius={4}
                                    />
                                </Feature>
                            ))}
                        </LoaderFeatureList>
                    </Card>
                ))}
            </Container>
        </Wrapper>
    );
};
